import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi, ZeytalTokens } from "@zeytal/types";

import { createAngularGradient } from "./angular-gradient.ts";
import { createDiamondGradient } from "./diamond-gradient.ts";
import { createLinearGradient } from "./linear-gradient.ts";
import { createRadialGradient } from "./radial-gradient.ts";
import { createSolidColor } from "./solid.ts";

export const colorMaker = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  colorValues: FigmaRestApi.Paint[],
) => {
  // Only handle single paint value styles.
  const [paint] = colorValues;
  let value = "" as ZeytalTokens.ColorStyleValue;

  if (paint?.type === "SOLID") {
    value = createSolidColor(stylesFormatsConfig, paint);
  } else if (paint?.type === "GRADIENT_LINEAR") {
    value = createLinearGradient(stylesFormatsConfig, paint);
  } else if (paint?.type === "GRADIENT_ANGULAR") {
    value = createAngularGradient(stylesFormatsConfig, paint);
  } else if (paint?.type === "GRADIENT_DIAMOND") {
    value = createDiamondGradient(stylesFormatsConfig, paint);
  } else if (paint?.type === "GRADIENT_RADIAL") {
    value = createRadialGradient(stylesFormatsConfig, paint);
  }

  return value;
};
